export default "__VITE_ASSET__DYi5ugb___"